const Footer = () => {
  return (
    <div className="footer text-center text-sm font-medium font-poppins h-10 flex justify-center items-center bg-slate-900 text-white">
      <h1 data-testid="footer">© 2023 made by Chinmay 🎉</h1>
    </div>
  );
};

export default Footer;
